import { Box } from '@mui/material';
import { TimelineEntry } from '../../../../types/customers';
import TimelineEntryRow from './TimelineEntryRow';

interface Props {
  entries: TimelineEntry[];
  hasMore: boolean;
  timezone: string;
}

function TimelineFeed({ entries, hasMore, timezone }: Props) {
  return (
    <Box>
      {entries.map((entry, index) => (
        <TimelineEntryRow
          key={entry.id}
          entry={entry}
          isLast={!hasMore && index === entries.length - 1}
          timezone={timezone}
        />
      ))}
    </Box>
  );
}

export default TimelineFeed;
